((app) => {
    app.component("policyInfoTable", {
        templateUrl: "/App/States/Policies/Detail/PolicyInfoTable/policy.info.table.html",
        controller: "infoCardCtrl",
        bindings: {
            cardTitle: "@",
            isExpanded: "=",
            isDisabled: "=",
            data: "<",
            selectors: "<",
            query: "<",
            moreDetail: "<",
            policyId: "<",
            initQuery: "<"
        }
    });
})(window.app);